export default {
      id: "ic_projects-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_projects",
      toString: function () {
        return this.url;
      }
    }